"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllRecordsItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var BUBBLE_OFFSET_X = 16;
exports.AllRecordsItem = function (_a) {
    var isSelected = _a.isSelected, onSelect = _a.onSelect;
    var className = classnames_1.default("gd-list-item", "gd-list-item-shortened", {
        "is-selected": isSelected,
    }, "gd-button-link", "s-rf-attribute-all-records");
    return (react_1.default.createElement("button", { className: className, onClick: function () { return onSelect(); } },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "rankingFilter.allRecords" }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0 },
                react_1.default.createElement("span", { className: "gd-icon-circle-question gd-rf-attribute-all-records-icon s-rf-attribute-all-records-icon" }),
                react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary gd-rf-tooltip-bubble s-rf-attribute-all-records-bubble", arrowOffsets: { "cr cl": [BUBBLE_OFFSET_X, 0], "cl cr": [-BUBBLE_OFFSET_X, 0] }, alignPoints: [{ align: "cr cl" }, { align: "cl cr" }] },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "rankingFilter.allRecords.tooltip" }))))));
};
//# sourceMappingURL=AllRecordsItem.js.map